package com.hyperether.goodjob.scenes.workspace

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.selection.SelectionContainer
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import com.hyperether.goodjob.getPlatformChecker
import com.hyperether.goodjob.isWebMobileView
import com.hyperether.goodjob.log
import com.hyperether.goodjob.models.Plan
import com.hyperether.goodjob.models.Role
import com.hyperether.goodjob.models.Workspace
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.access_dashboard
import com.hyperether.goodjob.resources.admin
import com.hyperether.goodjob.resources.choose_your_workspace
import com.hyperether.goodjob.resources.create_workspace
import com.hyperether.goodjob.resources.employee
import com.hyperether.goodjob.resources.last_accessed
import com.hyperether.goodjob.resources.logo_good_job
import com.hyperether.goodjob.resources.logout
import com.hyperether.goodjob.resources.manager
import com.hyperether.goodjob.resources.never
import com.hyperether.goodjob.resources.new_workspace
import com.hyperether.goodjob.resources.no_information
import com.hyperether.goodjob.resources.plan
import com.hyperether.goodjob.resources.plus
import com.hyperether.goodjob.resources.role
import com.hyperether.goodjob.resources.select_your_workspace
import com.hyperether.goodjob.scenes.components.clickableWithPointer
import com.hyperether.goodjob.scenes.components.disableMouseDragScrollOnWeb
import com.hyperether.goodjob.scenes.register.FilledButton
import com.hyperether.goodjob.scenes.user.UserViewModel
import com.hyperether.goodjob.theme.BlueApp
import com.hyperether.goodjob.theme.DarkGrey
import com.hyperether.goodjob.theme.LightGrey
import com.hyperether.goodjob.util.DateTimeUtil
import com.hyperether.goodjob.util.toScaleDp
import com.hyperether.goodjob.util.toScaleSp
import com.hyperether.resources.currentLanguage
import com.hyperether.resources.stringResource
import org.jetbrains.compose.resources.painterResource

@Composable
fun WorkspaceScreen(
    isMobileView: Boolean,
    workspaceViewModel: WorkspaceViewModel,
    continueToDashboard: () -> Unit,
    goToLanding: () -> Unit,
    addNewWorkspace: () -> Unit,
    userViewModel: UserViewModel,
    onLogout: () -> Unit
) {
    workspaceViewModel.roleMap = mapOf(
        stringResource(Res.string.admin) to Role.admin.name,
        stringResource(Res.string.manager) to Role.manager.name,
        stringResource(Res.string.employee) to Role.employee.name,
    )
    val selectedWorkspace = remember { mutableStateOf<String?>(null) }

    LaunchedEffect(Unit) {
        if (getPlatformChecker().isMobile()) {
            workspaceViewModel.loadRemoteData()
            userViewModel.loadRemoteData()
        } else {
            workspaceViewModel.init()
            userViewModel.init()
        }
    }

    LaunchedEffect(workspaceViewModel.getUser()) {
        if (workspaceViewModel.getUser() != null) {
            workspaceViewModel.fetchCurrentPlan()
        }
    }

//    LaunchedEffect(workspaceViewModel.workspaceList) {
//        workspaceViewModel.init()
//    }

    LaunchedEffect(Unit) {
        val wid = workspaceViewModel.getWidQuery()
        if (wid.isNotEmpty()) {
            if (userViewModel.getUser()?.role.equals(Role.superAdmin.name, ignoreCase = true)) {
                workspaceViewModel.clearWedQuery()
                wid.let { id ->
                    workspaceViewModel.workspaceId.value = id
                    workspaceViewModel.loadWorkspace {
                        if (it) {
                            userViewModel.loadRemoteData()
                            continueToDashboard()
                        }
                    }
                }
            } else {
                goToLanding()
            }
        }
    }

    Column(
        modifier = Modifier
            .fillMaxSize()
            .verticalScroll(rememberScrollState())
            .disableMouseDragScrollOnWeb()
            .padding(16.toScaleDp()),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        if (!isMobileView) {
            LogoHeader()
            Spacer(modifier = Modifier.height(40.toScaleDp()))
        }
        TitleSection(isMobileView)

        Spacer(modifier = Modifier.height(30.toScaleDp()))

        workspaceViewModel.getUser()?.let { user ->
            val status =
                workspaceViewModel.roleMap.entries.find { entry -> entry.value == user.role }?.key
            WorkspaceList(
                status ?: stringResource(Res.string.no_information),
                workspaceViewModel.currentPlan.value,
                isMobileView,
                workspaces = workspaceViewModel.workspaceList,
                selectedWorkspace.value,
                onWorkspaceSelected = {
                    selectedWorkspace.value = it.name
                    it._id?.let { id ->
                        workspaceViewModel.workspaceId.value = id
                        workspaceViewModel.loadWorkspace {
                            if (it) {
                                userViewModel.loadRemoteData()
                                continueToDashboard()
                            } else {
                                // TODO: present error
                            }
                        }
                    }
                },
            )
        }
        if (!isMobileView)
            Spacer(modifier = Modifier.height(32.toScaleDp()))
        else
            Spacer(modifier = Modifier.height(30.toScaleDp()))

        FilledButton(
            onClick = {
                workspaceViewModel.workspaceId.value.let {
                    workspaceViewModel.loadWorkspace {
                        if (it)
                            continueToDashboard()
                        else {
                            // TODO: present error
                        }
                    }
                }
            },
            isEnabled = selectedWorkspace.value != null,
            text = stringResource(Res.string.access_dashboard),
            modifier = Modifier.width(530.toScaleDp())
        )
        Spacer(modifier = Modifier.height(10.toScaleDp()))

        FilledButton(
            onClick = onLogout,
            text = stringResource(Res.string.logout),
            modifier = Modifier.width(530.toScaleDp())
        )

        if (!isMobileView) {
            Spacer(modifier = Modifier.height(30.toScaleDp()))
        } else {
            Spacer(modifier = Modifier.height(30.toScaleDp()))
        }

        if (workspaceViewModel.workspaceList.isEmpty()) {
            DividerLine(isMobileView)
            CreateWorkspaceSection(isMobileView, addNewWorkspace)
        }
    }
}

@Composable
fun LogoHeader() {
    Box(
        modifier =
            if (!isWebMobileView()) Modifier
                .fillMaxWidth()
                .padding(start = 56.toScaleDp(), top = 32.toScaleDp())
            else
                Modifier
                    .fillMaxWidth()
                    .padding(bottom = 70.toScaleDp()),
        contentAlignment = Alignment.TopStart
    ) {
        Image(
            painter = painterResource(Res.drawable.logo_good_job),
            contentDescription = null,
            modifier = if (!isWebMobileView()) Modifier.height(38.toScaleDp())
                .width(145.toScaleDp()) else Modifier
        )
    }
}

@Composable
fun TitleSection(isMobileView: Boolean) {
    Column(
        modifier = Modifier.fillMaxWidth(),
        horizontalAlignment = if (isMobileView) Alignment.Start else Alignment.CenterHorizontally
    ) {
        if (isMobileView)
            Spacer(modifier = Modifier.height(50.toScaleDp()))
        SelectionContainer {
            Text(
                fontWeight = FontWeight.Bold,
                text = stringResource(Res.string.select_your_workspace),
                color = Color.Black,
                textAlign = if (!isMobileView) TextAlign.Center else TextAlign.Start,
                fontSize = if (!isMobileView) 40.toScaleSp() else 24.toScaleSp(),
                lineHeight = if (!isMobileView) 50.toScaleSp() else 24.toScaleSp()
            )
        }
        Spacer(modifier = Modifier.height(15.toScaleDp()))
        SelectionContainer {
            Text(
                text = stringResource(Res.string.choose_your_workspace),
                color = DarkGrey,
                textAlign = TextAlign.Start,
                fontSize = if (!isMobileView) 18.toScaleSp() else 16.toScaleSp(),
                lineHeight = if (!isMobileView) 24.toScaleSp() else 16.toScaleSp()
            )
        }
    }
}

@Composable
fun WorkspaceList(
    role: String,
    plan: Plan? = null,
    isMobileView: Boolean,
    workspaces: List<Workspace>,
    selectedWorkspace: String?,
    onWorkspaceSelected: (Workspace) -> Unit
) {
    workspaces.forEach { workspace ->
        WorkspaceItem(
            isMobileView = isMobileView,
            title = workspace.name ?: stringResource(Res.string.no_information),
            role = role,
            lastAccessed = workspace.lastAccessed?.let {
                try {
                    it.toLong().let { it1 -> DateTimeUtil.formatLastAccessed(it1) }
                } catch (e: Exception) {
                    log.d("lastAccessed parser error") { "ERROR: ${e.message}" }
                    stringResource(Res.string.never)
                }
            } ?: stringResource(Res.string.never),
            plan = plan?.getName(currentLanguage.value.code) ?: "",
            isSelected = selectedWorkspace == workspace.name,
            onSelect = { onWorkspaceSelected(workspace) }
        )
        Spacer(modifier = Modifier.height(if (isMobileView) 16.toScaleDp() else 16.toScaleDp()))
    }
}

@Composable
fun DividerLine(isMobileView: Boolean) {
    Spacer(
        modifier = Modifier
            .height(if (isMobileView) 2.toScaleDp() else 1.toScaleDp())
            .background(LightGrey)
            .width(530.toScaleDp())
    )
}

@Composable
fun CreateWorkspaceSection(
    isMobileView: Boolean,
    addNewWorkspace: () -> Unit
) {
    Spacer(modifier = Modifier.height(if (isMobileView) 20.toScaleDp() else 24.toScaleDp()))
    Text(
        text = stringResource(Res.string.create_workspace),
        color = Color.Black,
        fontWeight = FontWeight.Bold,
        textAlign = if (!isMobileView) TextAlign.Center else TextAlign.Start,
        fontSize = if (isMobileView) 18.toScaleSp() else 18.toScaleSp()
    )
    Spacer(modifier = Modifier.height(if (isMobileView) 10.toScaleDp() else 12.toScaleDp()))
    Row(
        modifier = Modifier.clickableWithPointer { addNewWorkspace() },
        verticalAlignment = Alignment.CenterVertically
    ) {
        Image(
            painter = painterResource(Res.drawable.plus),
            contentDescription = null
        )
        Text(
            text = stringResource(Res.string.new_workspace),
            color = BlueApp,
            textAlign = TextAlign.Center,
            fontSize = if (isMobileView) 16.toScaleSp() else 16.toScaleSp(),
            modifier = Modifier.padding(start = if (isMobileView) 15.toScaleDp() else 8.toScaleDp())
        )
    }
}


@Composable
fun WorkspaceItem(
    isMobileView: Boolean,
    title: String,
    role: String,
    lastAccessed: String,
    plan: String,
    isSelected: Boolean,
    onSelect: () -> Unit
) {
    val commonModifier = if (isMobileView) Modifier
        .fillMaxWidth() else Modifier.width(530.toScaleDp())
    Box(
        modifier = commonModifier
            .border(
                width = if (isMobileView) {
                    if (isSelected) 2.toScaleDp() else 1.toScaleDp()
                } else {
                    if (isSelected) 2.toScaleDp() else 1.toScaleDp()
                },
                color = if (isSelected) BlueApp else Color.LightGray,
                shape = RoundedCornerShape(if (isMobileView) 8.toScaleDp() else 8.toScaleDp())
            )
            .background(
                Color.White,
                shape = RoundedCornerShape(if (isMobileView) 8.toScaleDp() else 8.toScaleDp())
            )
            .clickableWithPointer { onSelect() }
            .padding(if (isMobileView) 16.toScaleDp() else 16.toScaleDp())
    ) {
        Column {
            Text(
                text = title,
                fontSize = if (isMobileView) 18.toScaleSp() else 18.toScaleSp(),
                color = Color.Black,
                fontWeight = FontWeight.Bold,
                textAlign = TextAlign.Left
            )
            Row(modifier = Modifier.padding(top = if (isMobileView) 5.toScaleDp() else 8.toScaleDp())) {
                Text(
                    text = stringResource(Res.string.role) + ": ",
                    color = DarkGrey,
                    textAlign = TextAlign.Center,
                    fontSize = if (isMobileView) 14.toScaleSp() else 14.toScaleSp(),
                    lineHeight = if (isMobileView) 14.toScaleSp() else 24.toScaleSp()
                )
                Text(
                    text = role,
                    color = Color.Black,
                    fontWeight = FontWeight.Bold,
                    textAlign = TextAlign.Center,
                    fontSize = if (isMobileView) 14.toScaleSp() else 14.toScaleSp(),
                    lineHeight = if (isMobileView) 14.toScaleSp() else 24.toScaleSp()
                )
            }
            Row(modifier = Modifier.padding(top = if (isMobileView) 5.toScaleDp() else 2.toScaleDp())) {
                Text(
                    text = stringResource(Res.string.last_accessed),
                    color = DarkGrey,
                    textAlign = TextAlign.Center,
                    fontSize = if (isMobileView) 14.toScaleSp() else 14.toScaleSp(),
                    lineHeight = if (isMobileView) 14.toScaleSp() else 24.toScaleSp()
                )
                Text(
                    text = lastAccessed,
                    color = Color.Black,
                    fontWeight = FontWeight.Bold,
                    textAlign = TextAlign.Center,
                    fontSize = if (isMobileView) 14.toScaleSp() else 14.toScaleSp(),
                    lineHeight = if (isMobileView) 14.toScaleSp() else 24.toScaleSp()
                )
            }
            Row(modifier = Modifier.padding(top = if (isMobileView) 5.toScaleDp() else 2.toScaleDp())) {
                Text(
                    text = stringResource(Res.string.plan),
                    color = DarkGrey,
                    textAlign = TextAlign.Center,
                    fontSize = if (isMobileView) 14.toScaleSp() else 14.toScaleSp(),
                    lineHeight = if (isMobileView) 14.toScaleSp() else 24.toScaleSp()
                )
                Text(
                    text = plan,
                    color = Color.Black,
                    fontWeight = FontWeight.Bold,
                    textAlign = TextAlign.Center,
                    fontSize = if (isMobileView) 14.toScaleSp() else 14.toScaleSp(),
                    lineHeight = if (isMobileView) 14.toScaleSp() else 24.toScaleSp()
                )
            }
        }
    }
}
